/*
* Created on Oct 29, 2021
* @author: Adam Cheng <adamcheng@qnap.com>
*/
import React, {useCallback, useEffect, useRef, useState} from 'react';
import attention_svg from '../../static/img/utils/ic-sys-attention.svg';
import ic_next_line from '../../static/img/utils/ic-pagination-next-line.svg';
import HeaderUtilLangComponent from "./HeaderUtilLangComponent";
import {useTranslation} from "react-i18next";
import HeaderUtilLocationComponent from "./HeaderUtilLocationComponent";
import {SUPPORTED_LANGUAGES} from "../../service/common";
import {useCookiesSettings} from "../../context/CookiesSettingContext";
import ModalComponent from "../common/ModalComonent/ModalComponent";
import DetectRegionComponent from "../DetectRegionComponent";
import {useRegion} from "../../context/RegionContext";

const HeaderUtilSettingComponent = () => {
    const {t, i18n} = useTranslation()
    const [mainMenu, setMainMenu] = useState(false);
    const [subMenu, setSubMenu] = useState('');
    const [langMenu, setLangMenu] = useState(true);
    const [showSwitchDialog, setShowSwitchDialog] = useState(false);
    const [switchLang, setSwitchLang] = useState('');
    const {setShowSettings} = useCookiesSettings();
    const mainMenuNode = useRef();
    const langMenuNode = useRef();
    const buttonNode = useRef();
    const {region} = useRegion();

    const [showWarning, setShowWarning] = useState(false);
    const [switchTo, setSwitchTo] = useState('');

    const switchRegion = (value) => {
        setSwitchTo(value);
        setShowWarning(true);
    }

    const forceSwitch = () => {
        const pathname = window.location.pathname;
        window.location.href = `${window._env_.REACT_APP_ORGANIZATION_CENTER_DOMAIN}${pathname}?lang=${switchLang}`;
    }

    const toggleMainMenu = () => {
        setMainMenu(prev=> {
            return !prev
        })
    }

    const toggle = (e) => {
        // Check to see if the click is within the component itself.
        if (e.target.classList.contains('util-setting')) {
            toggleMainMenu();
        }
        // else if (langMenuNode?.current?.contains(e.target)) {
        //     setLangMenu(false);
        // }
        else if (mainMenuNode?.current && (!mainMenuNode?.current.contains(e.target))) {
            setMainMenu(false);
            // setLangMenu(false);
        }
        // else  if (buttonNode?.current != null && buttonNode?.current?.contains(e.target)) {
        //     toggleMainMenu();
        // }
        else {
            // setMainMenu(prev=>!prev);
        }
    }

    const closeAll = () => {
        setMainMenu(false);
        setLangMenu(false);
    }

    const showLang = useCallback(()=>{
        return SUPPORTED_LANGUAGES.find(l=>{
            if (i18n.language.startsWith('zh')) {
                if (i18n.language.toLowerCase().split(/[-_]/)[1] === 'tw') {
                    return l.value === 'zh_TW'
                }
                else {
                    return l.value === 'zh'
                }
            }
            return l.value===i18n.language
        })?.name;
    }, [i18n.language]);

    useEffect(() => {
        // When mount a component
        document.addEventListener("click", toggle)

        // When unmount a component
        return () => {
            document.removeEventListener("click", toggle);
        }
    }, [])

    return (
        <div className={`util-btn util-setting ${mainMenu ? 'active' : ''}`}  ref={buttonNode}>
            <div className={`comp-dropdown ${mainMenu? '' : 'hide'}`} ref={mainMenuNode}>
                <div className="multi-level-dropdown" data-secondary-menu={['language', 'region'].includes(subMenu) ? 'open' : 'close'}>
                    <div className="multi-level-dropdown__panel" data-menu-level="1">

                        <ul className="comp-dropdown-menu">
                            <li className="section">
                                <div className="section-head">{t('@Language@')}</div>
                                <div className={`section-items selection ${langMenu ? 'pending' : ''}`} onClick={()=>setSubMenu('language')}>
                                    <div className="section-items__group" onClick={()=>setLangMenu(true)}>
                                        <div className="select-label">{showLang()}</div>
                                        <div className="select-ic"></div>
                                    </div>
                                </div>
                            </li>
                            <li className="section-divide" />
                            <HeaderUtilLocationComponent subMenu={subMenu} setSubMenu={setSubMenu}/>
                            <li className="section-divide" />
                            <li className="section">
                                <div className="section-head">{t('@Management@')}</div>
                                <div className="section-items selection" onClick={()=>{setShowSettings(true); closeAll()}}>{t('@Cookies@')}</div>
                            </li>
                        </ul>
                    </div>

                    <div className="multi-level-dropdown__panel" data-menu-level="2">
                        <ul className="comp-dropdown-menu">
                            <li className="comp-dropdown-menu__navbar">
                                <div className="comp-dropdown-menu__navbar__back cursor-pointer"
                                     onClick={() => setSubMenu('')}>
                                    <div className="comp-dropdown-menu__navbar__arrow"></div>
                                    <div className="comp-dropdown-menu__navbar__label">{t('@Back@')}</div>
                                </div>
                            </li>
                            <li className="comp-dropdown-menu__scroll-content">
                                {langMenu &&
                                    <HeaderUtilLangComponent subMenu={subMenu} switchLang={setSwitchLang} dialog={setShowSwitchDialog}
                                                             node={langMenuNode}/>}

                                <ul className={subMenu === 'region' ? '' : 'hide'} data-option-ta="region">
                                    <li className="section">
                                        <div className={`section-items selection ${region === 'GLOBAL' ? 'active selected' : ''}`} onClick={() => switchRegion('GLOBAL')}>{t('@Global@')}</div>
                                        <div className={`section-items selection ${region === 'CHINA' ? 'active selected' : ''}`} onClick={() => switchRegion('CHINA')}>{t('@China@')}</div>
                                    </li>
                                    {/*<li className="comp-dropdown-menu__attention">*/}
                                    {/*    <div className="comp-dropdown-menu__attention-wrapper">*/}
                                    {/*        <div className="comp-dropdown-menu__attention__head">*/}
                                    {/*            <img src={attention_svg} className="w-14px"/>*/}
                                    {/*            <span>請注意</span>*/}
                                    {/*        </div>*/}
                                    {/*        <div>(待確認)*/}
                                    {/*            地區設定不但會影響裝置的連線、功能和內容，也會影響某些應用程式、應用工具、授權和憑證的有效性。為避免發生錯誤，請務必選擇正確的地區。*/}
                                    {/*        </div>*/}
                                    {/*    </div>*/}
                                    {/*</li>*/}
                                    <DetectRegionComponent showSwitchWarning={showWarning} switchTo={switchTo}/>
                                </ul>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>

            {showSwitchDialog && <ModalComponent isOpen={showSwitchDialog} onClose={() => setShowSwitchDialog(false)}
                                                 title={t('@Switch Region@')} okText={t('@Switch@')}
                                                 onSubmit={forceSwitch}>
                <div className="dialog-content">
                    <div
                        className="text-wrap">{t('@China region only supports Simplified Chinese. If you would like to browse with other languages, you must switch to Global region. Do you want to switch to the global region?@')}</div>
                    <div className="text-wrap">{t('@Note: Using global region in China may slow down your browsing experience.@')}</div>
                </div>
            </ModalComponent>}
        </div>
    );
};

export default HeaderUtilSettingComponent;